export const RESIDENT_ROLE_OPTIONS = [
  { value: 'CHU_HO', labelKey: 'residentRoleOwner' },
  { value: 'NHAN_KHAU', labelKey: 'residentRoleMember' },
] as const;

export const RESIDENT_RELATIONSHIP_OPTIONS = [
  { value: 'T', labelKey: 'relationshipTenant' },
  { value: 'T1', labelKey: 'relationshipContractHolder' },
  { value: 'H', labelKey: 'relationshipHusband' },
  { value: 'W', labelKey: 'relationshipWife' },
  { value: 'Bro', labelKey: 'relationshipBrother' },
  { value: 'Si', labelKey: 'relationshipSister' },
  { value: 'NB', labelKey: 'relationshipGrandson' },
  { value: 'NS', labelKey: 'relationshipGranddaughter' },
  { value: 'YB', labelKey: 'relationshipYoungerBrother' },
  { value: 'YS', labelKey: 'relationshipYoungerSister' },
  { value: 'F', labelKey: 'relationshipFather' },
  { value: 'M', labelKey: 'relationshipMother' },
  { value: 'GF', labelKey: 'relationshipGrandfather' },
  { value: 'GM', labelKey: 'relationshipGrandmother' },
  { value: 'A', labelKey: 'relationshipAunt' },
  { value: 'U', labelKey: 'relationshipUncle' },
  { value: 'MA', labelKey: 'relationshipCleaner' },
  { value: 'D', labelKey: 'relationshipSecurity' },
  { value: 'S', labelKey: 'relationshipStaff' },
  { value: 'AU', labelKey: 'relationshipAuthorized' },
  { value: 'Mil', labelKey: 'relationshipMotherInLaw' },
  { value: 'Fil', labelKey: 'relationshipFatherInLaw' },
  { value: 'Dil', labelKey: 'relationshipDaughterInLaw' },
  { value: 'Sil', labelKey: 'relationshipSonInLaw' },
  { value: 'Gr', labelKey: 'relationshipGrandchild' },
  { value: 'Bril', labelKey: 'relationshipBrotherInLaw' },
  { value: 'Sisil', labelKey: 'relationshipSisterInLaw' },
  { value: 'Fr', labelKey: 'relationshipFriend' },
  { value: 'Hou', labelKey: 'relationshipHousekeeper' },
  { value: 'OO', labelKey: 'relationshipFormerOwner' },
  { value: 'O', labelKey: 'relationshipOwner' },
  { value: 'SON', labelKey: 'relationshipSon' },
  { value: 'DAU', labelKey: 'relationshipDaughter' },
  { value: 'P', labelKey: 'relationshipPartner' },
  { value: 'R', labelKey: 'relationshipRelative' },
  { value: 'WH', labelKey: 'relationshipSpouse' },
  { value: 'SONDAU', labelKey: 'relationshipChild' },
] as const;

export const RESIDENT_NATIONALITY_OPTIONS = [
  { value: 'VN', labelKey: 'nationalityVietnam' },
  { value: 'NN', labelKey: 'nationalityForeign' },
] as const;

export const RESIDENT_GENDER_OPTIONS = [
  { value: 'MALE', labelKey: 'genderMale' },
  { value: 'FEMALE', labelKey: 'genderFemale' },
  { value: 'OTHER', labelKey: 'genderOther' },
] as const;

export function getRelationshipLabelByCode(code: string | undefined, t: (key: string) => string): string {
  if (!code) return '';
  const match = RESIDENT_RELATIONSHIP_OPTIONS.find((item) => item.value === code);
  return match ? t(match.labelKey) : code;
}

export function getResidentRoleLabel(role: string | undefined, t: (key: string) => string): string {
  if (!role) return '';
  const match = RESIDENT_ROLE_OPTIONS.find((item) => item.value === role);
  if (match) return t(match.labelKey);
  const legacy: Record<string, string> = {
    OWNER: t('residentRoleOwner'),
    TENANT: t('tenantRole'),
    FAMILY: t('familyRole'),
    CORPORATE_REPRESENTATIVE: t('corporateRepresentativeRole'),
    CORPORATE_EMPLOYEE: t('corporateEmployeeRole'),
  };
  return legacy[role] || role;
}

export function getGenderLabel(gender: string | undefined, t: (key: string) => string): string {
  if (!gender) return '';
  const match = RESIDENT_GENDER_OPTIONS.find((item) => item.value === gender);
  return match ? t(match.labelKey) : gender;
}

export function getNationalityLabel(code: string | undefined, t: (key: string) => string): string {
  if (!code) return '';
  const match = RESIDENT_NATIONALITY_OPTIONS.find((item) => item.value === code);
  return match ? t(match.labelKey) : code;
}
